/**
 * Irish Translations — Impact Core i18n
 *
 * Flat key-value structure. Keys use dot notation for namespacing.
 * Coverage: navigation, actions, statuses, dashboard labels, form labels.
 */

export const ga: Record<string, string> = {
  // Navigation
  'nav.dashboard': 'Deais',
  'nav.funds': 'Cistí',
  'nav.investments': 'Infheistíochtaí',
  'nav.investees': 'Infheistithe',
  'nav.esg': 'ESG Athbhreithniú',
  'nav.compliance': 'Comhlíonadh',
  'nav.reports': 'Tuairiscí',
  'nav.settings': 'Socruithe',
  'nav.users': 'Úsáideoirí',
  'nav.sfdr': 'SFDR',
  'nav.pai': 'PAI Táscairí',
  'nav.taxonomy': 'Tacsanomaíocht AE',
  'nav.filings': 'Comhduithe',
  'nav.calendar': 'Féilire',
  'nav.submit': 'Cuir sonraí isteach',
  'nav.submissions': 'Mo chuid aighneachtaí',
  'nav.benchmarks': 'Tagarmharcanna',
  'nav.messages': 'Teachtaireachtaí',
  'nav.portfolio': 'Punann',
  'nav.performance': 'Feidhmíocht cistí',
  'nav.esgSummary': 'ESG Achoimre',
  'nav.pipeline': 'Píblíne',
  'nav.dueDiligence': 'Dícheall cuí',
  'nav.impact': 'Méadracht tionchair',
  'nav.sdg': 'Mapáil SFI',
  'nav.audit': 'Rian iniúchta',
  'nav.snapshots': 'Grianghraif sonraí',
  'nav.knowledgeGraph': 'Graf eolais',
  'nav.geographic': 'Geografach',
  'nav.bi': 'BI Stiúideo',
  'nav.ai': 'AI Cúntóir',
  'nav.tasks': 'Tascanna',
  'nav.csrd': 'CSRD',
  'nav.regulatory': 'Monatóir rialála',

  // Common Actions
  'action.create': 'Cruthaigh',
  'action.edit': 'Cuir in eagar',
  'action.delete': 'Scrios',
  'action.save': 'Sábháil',
  'action.cancel': 'Cealaigh',
  'action.submit': 'Cuir isteach',
  'action.approve': 'Faomh',
  'action.reject': 'Diúltaigh',
  'action.download': 'Íoslódáil',
  'action.export': 'Easpórtáil',
  'action.import': 'Iompórtáil',
  'action.filter': 'Scag',
  'action.search': 'Cuardaigh',
  'action.refresh': 'Athnuaigh',
  'action.close': 'Dún',
  'action.back': 'Ar ais',
  'action.next': 'Ar aghaidh',
  'action.previous': 'Roimhe seo',
  'action.viewAll': 'Féach ar fad',
  'action.viewDetails': 'Féach ar shonraí',
  'action.generate': 'Gin',
  'action.signOut': 'Sínigh amach',
  'action.addNew': 'Cuir nua leis',
  'action.invite': 'Tabhair cuireadh',

  // Statuses
  'status.draft': 'Dréacht',
  'status.submitted': 'Curtha isteach',
  'status.validated': 'Bailíochtaithe',
  'status.approved': 'Faofa',
  'status.rejected': 'Diúltaithe',
  'status.pending': 'Ar feitheamh',
  'status.inProgress': 'Ar siúl',
  'status.overdue': 'Thar téarma',
  'status.compliant': 'Comhlíontach',
  'status.filed': 'Comhdaithe',
  'status.active': 'Gníomhach',
  'status.inactive': 'Neamhghníomhach',
  'status.closed': 'Dúnta',
  'status.fundraising': 'Tiomsú airgid',
  'status.investing': 'Ag infheistiú',
  'status.harvesting': 'Ag baint',

  // Dashboard Labels
  'dashboard.portfolioOverview': 'Forbhreathnú punainne',
  'dashboard.complianceStatus': 'Stádas comhlíonta',
  'dashboard.collectionProgress': 'Dul chun cinn bailithe',
  'dashboard.activityFeed': 'Gníomhaíocht',
  'dashboard.quickActions': 'Gníomhartha tapa',
  'dashboard.investmentPipeline': 'Píblíne infheistíochta',
  'dashboard.totalFunds': 'Cistí iomlána',
  'dashboard.aum': 'AUM',
  'dashboard.activeInvestments': 'Infheistíochtaí gníomhacha',
  'dashboard.totalInvestees': 'Infheistithe',
  'dashboard.recentActivity': 'Gníomhaíocht le déanaí',

  // LP Dashboard Labels
  'lp.totalCommitted': 'Iomlán tiomanta',
  'lp.capitalCalled': 'Caipiteal glaoite',
  'lp.distributed': 'Dáilte',
  'lp.netPosition': 'Glansuíomh',
  'lp.tvpi': 'TVPI',
  'lp.dpi': 'DPI',
  'lp.fundPerformance': 'Feidhmíocht cistí',
  'lp.esgSummary': 'ESG Achoimre',
  'lp.reportLibrary': 'Leabharlann tuairiscí',
  'lp.taxonomyAligned': 'Ailínithe le tacsanomaíocht',
  'lp.paiCoverage': 'PAI Clúdach',
  'lp.portfolioPerformance': 'Feidhmíocht punainne LP',

  // Fund Labels
  'fund.name': 'Ainm an chiste',
  'fund.code': 'Cód an chiste',
  'fund.vintage': 'Bliain bhunaithe',
  'fund.size': 'Méid an chiste',
  'fund.targetSize': 'Spriocmhéid',
  'fund.currency': 'Airgeadra',
  'fund.strategy': 'Straitéis',
  'fund.status': 'Stádas',
  'fund.sfdrCategory': 'SFDR Catagóir',
  'fund.geographyFocus': 'Fócas geografach',
  'fund.sectorFocus': 'Fócas earnála',

  // Form Labels
  'form.name': 'Ainm',
  'form.email': 'Ríomhphost',
  'form.country': 'Tír',
  'form.amount': 'Méid',
  'form.currency': 'Airgeadra',
  'form.date': 'Dáta',
  'form.description': 'Cur síos',
  'form.notes': 'Nótaí',
  'form.type': 'Cineál',
  'form.period': 'Tréimhse',
  'form.year': 'Bliain',
  'form.required': 'Riachtanach',
  'form.optional': 'Roghnach',

  // Table Headers
  'table.fund': 'Ciste',
  'table.commitment': 'Gealltanas',
  'table.called': 'Glaoite',
  'table.distributed': 'Dáilte',
  'table.tvpi': 'TVPI',
  'table.status': 'Stádas',
  'table.regulation': 'Rialachán',
  'table.filingType': 'Cineál comhdaithe',
  'table.reportingPeriod': 'Tréimhse',
  'table.createdAt': 'Cruthaithe',
  'table.actions': 'Gníomhartha',

  // Compliance
  'compliance.sfdr': 'SFDR',
  'compliance.taxonomy': 'Tacsanomaíocht AE',
  'compliance.pai': 'PAI',
  'compliance.dataCompleteness': 'Iomláine sonraí',
  'compliance.nextDeadline': 'An chéad spriocdháta eile',

  // Reports
  'report.quarterly': 'Tuairisc ráithiúil',
  'report.annual': 'Tuairisc bhliantúil',
  'report.paiStatement': 'PAI Ráiteas',
  'report.taxonomyReport': 'Tuairisc tacsanomaíochta',
  'report.generatedAt': 'Ginte',
  'report.version': 'Leagan',

  // General
  'general.loading': 'Ag lódáil...',
  'general.noData': 'Níl aon sonraí ar fáil',
  'general.error': 'Tharla earráid',
  'general.retry': 'Bain triail eile as',
  'general.total': 'Iomlán',
  'general.page': 'Leathanach',
  'general.of': 'as',
  'general.showing': 'Ag taispeáint',
  'general.results': 'torthaí',
  'general.language': 'Teanga',
  'general.english': 'Béarla',
  'general.french': 'Fraincis',

  // Tour
  'tour.takeTour': 'Dean turas',
  'tour.skip': 'Sceipeail',
  'tour.next': 'Ar aghaidh',
  'tour.prev': 'Siar',
  'tour.finish': 'Criochnaigh',
};
